import { useState, useEffect, useMemo } from 'react';
import { RANDOM_SITES, BANNER_ADS } from '../parody-data.js';

export const RandomSitePage = ({ onNavigate }) => {
  const [site, setSite] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate dial-up loading
    setIsLoading(true);
    const loadTime = 2000 + Math.random() * 2000;
    const timeout = setTimeout(() => {
      const randomSite = RANDOM_SITES[Math.floor(Math.random() * RANDOM_SITES.length)];
      setSite(randomSite);
      setIsLoading(false);
    }, loadTime);
    return () => clearTimeout(timeout);
  }, []);

  const handleNewRandom = () => {
    setIsLoading(true);
    setTimeout(() => {
      const randomSite = RANDOM_SITES[Math.floor(Math.random() * RANDOM_SITES.length)];
      setSite(randomSite);
      setIsLoading(false);
    }, 1500 + Math.random() * 1500);
  };

  const randomAd = useMemo(() => BANNER_ADS[Math.floor(Math.random() * BANNER_ADS.length)], []);

  if (isLoading) {
    return (
      <div className="random-loading" data-testid="random-loading">
        <div className="loading-content">
          <div className="dialup-animation">
            <div className="modem-icon">MODEM</div>
            <div className="modem-sounds">
              <span>CONNECTING...</span>
              <span className="sound-text">beeeeep boop boop ksssshhhhh</span>
            </div>
          </div>
          <div className="loading-bar-container">
            <div className="loading-bar">
              <div className="loading-progress"></div>
            </div>
            <span className="loading-percent">Loading random website...</span>
          </div>
          <p className="loading-tip">Tip: Don't pick up the phone while surfing.</p>
        </div>
      </div>
    );
  }

  const renderSiteContent = () => {
    switch (site?.content) {
      case 'hamster':
        return (
          <div className="hamster-site">
            <h1>HAMPSTER DANCE</h1>
            <div className="hamster-grid">
              {[...Array(20)].map((_, i) => (
                <span key={i} className="dancing-hamster">HAMSTER</span>
              ))}
            </div>
            <p className="hamster-text">da ba dee da ba die da ba dee da ba die</p>
            <marquee className="hamster-marquee" scrollamount="8">
              HAMPSTER DANCE! THE ORIGINAL VIRAL SENSATION!
            </marquee>
          </div>
        );
      case 'base':
        return (
          <div className="base-site">
            <h1>ALL YOUR BASE ARE BELONG TO US</h1>
            <div className="base-image">BASE</div>
            <div className="base-text">
              <p>In A.D. 2101, war was beginning.</p>
              <p className="captain">Captain: What happen?</p>
              <p className="mechanic">Mechanic: Somebody set up us the bomb.</p>
              <p className="operator">Operator: We get signal.</p>
              <p className="captain">Captain: What!</p>
              <p className="cats">CATS: All your base are belong to us.</p>
              <p className="cats">CATS: You have no chance to survive make your time.</p>
              <p className="captain">Captain: Move 'ZIG'.</p>
              <p className="captain">Captain: For great justice.</p>
            </div>
          </div>
        );
      case 'badger':
        return (
          <div className="badger-site">
            <h1>BADGER BADGER BADGER</h1>
            <div className="badger-animation">
              {[...Array(12)].map((_, i) => (
                <span key={i} className="dancing-badger">BADGER</span>
              ))}
            </div>
            <div className="badger-lyrics">
              <p>Badger badger badger badger badger badger badger badger</p>
              <p className="mushroom">MUSHROOM MUSHROOM!</p>
              <p>Badger badger badger badger badger badger badger badger</p>
              <p className="snake">A SNAKE A SNAKE!</p>
              <p className="ooh">Ooooh it's a snaaaake!</p>
            </div>
          </div>
        );
      case 'pbj':
        return (
          <div className="pbj-site">
            <h1>PEANUT BUTTER JELLY TIME!</h1>
            <div className="banana-dance">
              <span className="dancing-banana">BANANA</span>
            </div>
            <div className="pbj-lyrics">
              <p>It's peanut butter jelly time!</p>
              <p>Peanut butter jelly time!</p>
              <p>Peanut butter jelly time!</p>
              <p className="where-at">Where ya at? Where ya at?</p>
              <p className="there-ya-go">There ya go! There ya go!</p>
              <p>Peanut butter jelly! Peanut butter jelly!</p>
            </div>
            <div className="banana-row">
              {[...Array(10)].map((_, i) => (
                <span key={i} className="mini-banana">BANANA</span>
              ))}
            </div>
          </div>
        );
      case 'starwars':
        return (
          <div className="starwars-site">
            <h1>STAR WARS KID FAN SITE</h1>
            <div className="swk-content">
              <div className="swk-image">FAN</div>
              <p className="quote">"The force is strong with this one"</p>
              <div className="fan-stuff">
                <h3>FAN REMIXES:</h3>
                <ul>
                  <li>Star Wars Kid vs. Darth Maul</li>
                  <li>Star Wars Kid: The Matrix Edition</li>
                  <li>Star Wars Kid: Lord of the Rings</li>
                  <li>Star Wars Kid: Kill Bill Style</li>
                </ul>
              </div>
              <p className="views">Views: 900,000,000+</p>
            </div>
          </div>
        );
      case 'homestar':
        return (
          <div className="homestar-site">
            <h1>HOMESTAR RUNNER</h1>
            <div className="homestar-content">
              <div className="character-row">
                <span className="character">H</span>
                <span className="character">S</span>
                <span className="character">R</span>
              </div>
              <p className="homestar-quote">"Everybody! Everybody!"</p>
              <div className="sbemails">
                <h3>STRONG BAD EMAILS:</h3>
                <ul>
                  <li>guitar</li>
                  <li>techno</li>
                  <li>dragon</li>
                  <li>japanese cartoon</li>
                </ul>
              </div>
              <p className="trogdor">TROGDOR THE BURNINATOR!</p>
              <p className="burninate">Burninating the countryside! Burninating the peasants!</p>
            </div>
          </div>
        );
      default:
        return (
          <div className="default-random">
            <h1>Random Website</h1>
            <p>You found a mysterious corner of the internet!</p>
          </div>
        );
    }
  };

  return (
    <div className="random-site-page" data-testid="random-site-page">
      {/* Header */}
      <div className="random-header">
        <h2>You discovered: {site?.name}</h2>
        <p className="random-desc">{site?.description}</p>
      </div>

      {/* Ad Banner */}
      <div className="random-banner blinking" style={{ backgroundColor: randomAd.color }}>
        {randomAd.text} - {randomAd.subtext}
      </div>

      {/* Main Content */}
      <div className="random-content">
        {renderSiteContent()}
      </div>

      {/* Controls */}
      <div className="random-controls">
        <button className="random-btn" onClick={handleNewRandom} data-testid="new-random-btn">
          Take Me Somewhere Else
        </button>
        <button className="back-btn" onClick={() => onNavigate('portal')}>
          Back to Portal
        </button>
      </div>

      {/* Visitor Counter */}
      <div className="random-footer">
        <div className="visitor-badge">
          <span>You are visitor #</span>
          <span className="counter">{Math.floor(Math.random() * 999999)}</span>
        </div>
        <p className="footer-text">
          Surfing the Information Superhighway since 1997 - Your ISP is watching
        </p>
        <div className="webring">
          <span>Previous</span>
          <span>| Random Site Ring |</span>
          <span>Next</span>
        </div>
      </div>
    </div>
  );
};

export default RandomSitePage;
